import { EAgentReferralQueryKey } from './agent-referral.types'
import userReferralService from './agent-referral.service'

export const getAgentReferralCodesOptions = () => {
  return {
    queryKey: [EAgentReferralQueryKey.GET_AGENT_REFERRAL_CODES],
    queryFn: () => userReferralService.getAgentReferralCodes(),
  }
}
